import React, { FC } from 'react'
import { Box, Text } from '@moonpig/launchpad-components'
import { ModuleContext, ModuleHeading } from '../types'
import { useProductsLocaleText } from '../../locale'
import { StepHeading } from '../../components/StepHeading'

type Props = {
  module: ModuleHeading
  context: ModuleContext
}

export const HeadingModule: FC<Props> = ({ module: { textType } }) => {
  const localiseText = useProductsLocaleText()

  const getHeading = () => {
    if (textType === 'step heading') {
      return <StepHeading activeStep={1} totalSteps={3} />
    }
    return (
      <Box mb={{ xs: 0, md: 10 }}>
        <Text
          color="colorTextHeadline"
          typography={{ xs: 'typeMobileDisplay03', md: 'typeDesktopDisplay05' }}
        >
          {localiseText('heading')}
        </Text>
      </Box>
    )
  }
  return <Box data-testid="module-heading">{getHeading()}</Box>
}
